
import React, { useState } from "react";

const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <div>
      <div className="p-2 mt-[17px]">
        <div className="flex  gap-[8px] justify-end">
          <button
  onClick={() => setActiveTab("overview")}
  className={`px-4 py-2 font-medium shadow-sm  text-[#3F3F3F]  border border-[#E8E8EB] w-[100px] rounded-[4px] ${
    activeTab === "overview"
      ? "bg-[#bb1ccc] text-white"
      : "bg-white text-[#3F3F3F] hover:bg-gray-100"
  }`}
>
  Overview
</button>

<button
  onClick={() => setActiveTab("assets")}
  className={`px-4 py-2  font-medium shadow-sm  text-[#3F3F3F]  border border-[#E8E8EB]  w-[100px] rounded-[4px] ${
    activeTab === "assets"
      ? "bg-[#bb1ccc] text-white"
      : "bg-white  text-[#3F3F3F]  hover:bg-gray-100"
  }`}
>
  Assets 
</button>

<button
  onClick={() => setActiveTab("rules")}
  className={`px-4 py-2  font-medium  text-[#3F3F3F]  shadow-sm border border-[#E8E8EB] w-[100px] rounded-[4px] ${
    activeTab === "rules"
      ? "bg-[#bb1ccc] text-white"
      : "bg-white  text-[#3F3F3F]  hover:bg-gray-100"
  }`}
>
  Rule 
</button>

{/* <button
  onClick={() => setActiveTab("reports")}
  className={`px-4 py-2  font-medium  text-[#3F3F3F]  shadow-sm border border-[#E8E8EB]  w-[100px] rounded-[4px] ${
    activeTab === "reports"
      ? "bg-[#9897FF] text-white"
      : "bg-white  text-[#3F3F3F]  hover:bg-gray-100"
  }`}
>
  About 
</button> */}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
